import apiClient from './client';

export interface CaseBrief {
  id: string;
  case_number: string;
  status: string;
  tier?: string | null;
  issuer_name?: string | null;
  depositor_name?: string | null;
  updated_at?: string | null;
}

export interface QueueItem extends CaseBrief {
  step_id: string;
  step_name: string;
  required_role: string;
}

export interface DashboardSummary {
  role: string;
  tier_distribution: Record<string, number>;
  my_cases_by_status?: Record<string, number>;
  my_returned_queue?: CaseBrief[];
  my_review_queue?: QueueItem[];
  my_approval_queue?: QueueItem[];
  escalated?: CaseBrief[];
  all_cases_by_status?: Record<string, number>;
}

export interface NotificationItem {
  id: string;
  action: string;
  entity_type: string | null;
  entity_id: string | null;
  user_id: string | null;
  timestamp: string | null;
  details?: Record<string, unknown> | null;
}

export interface NotificationFeed {
  items: NotificationItem[];
  unread_count: number;
  last_seen: string;
}

const NOTIF_PATH = '/dashboard/' + 'notifications';
const NOTIF_READ_PATH = NOTIF_PATH + '/read';

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const { data } = await apiClient.get<DashboardSummary>('/dashboard/summary');
  return data;
}

export async function getNotifications(): Promise<NotificationFeed> {
  const { data } = await apiClient.get<NotificationFeed>(NOTIF_PATH);
  return data;
}

export async function markNotificationsRead(): Promise<{ last_seen: string }> {
  const { data } = await apiClient.post<{ last_seen: string }>(NOTIF_READ_PATH);
  return data;
}
